export enum CURRENCY {
    RUPEE = "RUPEE",
    DOLLAR = "DOLLAR",
  }